export default "/fonts/feather.woff?3fa166a56aa3839c5d12598e38b2d877";